import Vue from 'vue'
import Vuex from 'vuex'
import lib from '@/library'
import config from '@/config'

import siteNavigationState from '@/store/modules/sitenavigation'
import meetingState from '@/store/modules/meeting'
import raceState from '@/store/modules/race'
import resultsState from '@/store/modules/hrresults'
import betslipState from '@/store/modules/betslip'
// import playHistoryState from '@/store/modules/playhistory'
import statementState from '@/store/modules/statement'
import accountState from '@/store/modules/account'
import bonavigationState from '@/store/modules/sports/bonavigation'
import marketgroupState from '@/store/modules/sports/marketgroup'
import sbBetslipState from '@/store/modules/sports/betslip/index'
import livebettingState from '@/store/modules/sports/livebetting'
import screenState from '@/store/modules/screen'
import overlayState from '@/store/modules/overlay'
import eventState from '@/store/modules/sports/event'
import tncState from '@/store/modules/tnc'
import geocomply from '@/library/geocomply'
import mobileBridge from '@/library/mobileBridge'
import router from '@/router'
// import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)

export default new Vuex.Store({
  // plugins: [createPersistedState()],
  state: {
    language: 'US',
    accountDetails: undefined,
    personalDetails: undefined,
    sessionDetails: undefined,
    walletBalance: undefined,
    onePayToken: undefined,
    winningTransaction: undefined,
    loginErrorMessage: '',
    logInService: 'UserService',
    isOpenedFromWebView: false,
    mobileGeolocationInProgress: false,
    loginChallenges: undefined,
    loginChallengesTermsConditions: undefined,
    formSubmitSppiner: false,
    pageLoader: false,
    geolocated: false,
    loginTime: 0,
    showBalance: true,
    webViewAndMobile: false,
    debugLevel: false,
    optionalISOStates: ['WV', 'LND', 'LCY', 'LA', 'CA', 'NY', 'IE', 'L'], // west virginia, middle london, london, greater london, los angeles, california,  los angeles, new york, 'ireland'
    optionalEnvironment: ['development'], // mockaup GAN geocomply
    igtcLastLoginDetails: undefined
  },

  getters: {
    getLoginChallenges (state) {
      return state.loginChallenges
    },
    getLoginChallengesTermsConditions (state) {
      return state.loginChallengesTermsConditions
    },
    getSessionDetails (state) {
      return state.sessionDetails
    },
    getLoginTime (state) {
      return state.loginTime
    },
    getLanguage (state) {
      return state.language
    },
    getAccountDetails (state) {
      return state.accountDetails
    },
    getOnePayTokenValue (state) {
      return state.onePayToken
    },
    isLoggedIn (state) {
      if (state.accountDetails !== undefined) localStorage.loggedIn = true
      return state.accountDetails !== undefined || state.accountDetails !== undefined
    },
    getLoginErrorMessage (state) {
      return state.loginErrorMessage
    },
    getPersonalDetails (state) {
      return state.personalDetails
    },
    getIsOpenedFromWebView (state) {
      let check = ('webView' in localStorage) ? JSON.parse(localStorage.getItem('webView')) : false
      return state.isOpenedFromWebView ? true : check
    },
    getWalletBalance (state) {
      return state.walletBalance
    },
    getFormSubmitSppiner (state) {
      return state.formSubmitSppiner
    },
    getPageLoader (state) {
      return state.pageLoader
    },
    getGeolocated (state) {
      return state.geolocated
    },
    getShowBalance (state) {
      return state.showBalance
    },
    getDebugLevel (state) {
      return state.debugLevel
    },
    getWebViewAndMobile (state) {
      return state.webViewAndMobile
    },
    getMobileGeolocationInProgress (state) {
      return state.mobileGeolocationInProgress
    },
    getDevice (getters) {
      var device = ''

      if (/Android/i.test(navigator.userAgent)) {
        if (getters.isOpenedFromWebView) {
          device = 'ANDROID_PHONE'
        } else {
          device = 'ANDROID_PHONE_HTML5'
        }
      } else if (/iPhone/i.test(navigator.userAgent)) {
        if (getters.isOpenedFromWebView) {
          device = 'IOS_PHONE'
        } else {
          device = 'IOS_PHONE_HTML5'
        }
      } else if (/iPad|iPod/i.test(navigator.userAgent)) {
        if (getters.isOpenedFromWebView) {
          device = 'IOS_TABLET'
        } else {
          device = 'IOS_TABLET_HTML5'
        }
      } else {
        device = 'OTHERS'
      }

      return device
    },
    getWinningTransaction (state) {
      return state.winningTransaction
    },
    getIgtcLastLoginDetails (state) {
      return state.igtcLastLoginDetails
    }
  },

  mutations: {
    setAccountDetails (state, accountDetails) {
      state.accountDetails = accountDetails
    },
    setLoginErrorMessage (state, error) {
      state.loginErrorMessage = error
    },
    setPersonalDetails (state, personalDetails) {
      state.personalDetails = personalDetails
    },
    setSessionDetails (state, sessionDetails) {
      state.sessionDetails = sessionDetails
    },
    setLoginTime (state, loginTime) {
      state.loginTime = loginTime
    },
    setWalletBalance (state, balance) {
      state.walletBalance = balance
    },
    setOnePayToken (state, onePayToken) {
      state.onePayToken = onePayToken
    },
    setIsOpenedFromWebView (state, isOpenedFromWebView) {
      state.isOpenedFromWebView = isOpenedFromWebView
    },
    setLoginChallenges (state, data) {
      state.loginChallenges = data
    },
    setLoginChallengesTermsConditions (state, data) {
      state.loginChallengesTermsConditions = data
    },
    setFormSubmitSppiner (state, data) {
      state.formSubmitSppiner = data
    },
    setPageLoader (state, data) {
      state.pageLoader = data
    },
    setGeolocated (state, data) {
      state.geolocated = data
    },
    setShowBalance (state, data) {
      state.showBalance = data
    },
    setDebugLevel (state, level) {
      state.debugLevel = level
    },
    setWebViewAndMobile (state, data) {
      state.webViewAndMobile = data
    },
    setMobileGeolocationInProgress (state, data) {
      state.mobileGeolocationInProgress = data
    },
    setWinningTransaction (state, data) {
      state.winningTransaction = data
    },
    setIgtcLastLoginDetails (state, data) {
      state.igtcLastLoginDetails = data
    }
  },

  actions: {
    login (context, request) {
      console.log('Login')
      // context.dispatch('userServiceLogin', request)
      // geocomply.geoComplyService('C00DB8EE-24B5-43E0-9003-D759CF6A0C4E')
      context.dispatch('igtcServiceLogin', request)
      localStorage.removeItem('last-keep')
    },
    CompleteChallenge (context, request) {
      context.dispatch('ganServiceCompleteChallenge', request)
    },
    CompleteChallengeTermsConditions (context, request) {
      context.dispatch('ganServiceCompleteChallenge', request)
    },
    userServiceLogin (context, request) {
      console.log('UserService Login')
      context.state.logInService = 'UserService'

      lib.rpcService.callBroker('UserService', 'Login', {
        'username': request.username,
        'password': request.password,
        'affiliateId': null
      }).then(response => {
        if (response && response.result && !response.result.exceptionType) {
          // logged in

          context.commit('setLoginErrorMessage', '')
          context.dispatch('getAccountDetails')
          context.dispatch('getPersonalDetails')
        } else {
          // login failed
          context.commit('setLoginErrorMessage', response.result.message || 'Login failed. Unknown error occurred')
          context.commit('setPersonalDetails', undefined)
          context.commit('setSessionDetails', undefined)
        }
      }).catch((error) => {
        console.log(error)

        context.commit('setLoginErrorMessage', error.message || 'Login failed. Unknown error occurred')
        context.commit('setPersonalDetails', undefined)
        context.commit('setSessionDetails', undefined)
      })
    },
    igtcServiceLogin (context, request) {
      context.commit('setFormSubmitSppiner', true)
      // context.commit('setGeolocated', true)
      context.commit('setLoginErrorMessage', '')
      context.state.logInService = 'IGTConnectService'

      lib.rpcService.callBroker('IGTConnectService', 'Login', {
        'username': request.username,
        'password': request.password,
        'getBalances': true,
        'device': context.getters['getDevice'],
        'IDMDRegion': 'ignore',
        'IDMDLanguage': 'ignore'
      }).then(response => {
        context.dispatch('onLoginSuccess', response)
        context.commit('setFormSubmitSppiner', false)
        if (context.getters['getIsOpenedFromWebView'] && config.app.autoconf.BRAND === 'ri') {
          var password = request.password
          if (request.faceId) {
            password = null
          }
          mobileBridge.mobileUserLogin(response, password)
        }
      }).catch((error) => {
        context.dispatch('onLoginError', error)
        context.commit('setFormSubmitSppiner', false)
        context.commit('setGeolocated', false)
      })
    },
    fetchIgtcLastLoginDetails (context) {
      lib.rpcService.callBroker('IGTConnectService', 'GetLastLoginDetails', {
        'device': context.getters['getDevice']
      }).then(response => {
        context.commit('setIgtcLastLoginDetails', response && response.result && response.result.loginDetails)
      }).catch((error) => {
        console.log('fetchIgtcLastLoginDetails failed: ' + error.message)
        context.commit('setIgtcLastLoginDetails', undefined)
      })
    },
    onLoginSuccess (context, response) {
      if (response && response.result && response.result.login && response.result.login.isLoginSuccessful === true) {
        // logged in
        context.commit('setLoginErrorMessage', '')
        context.dispatch('getAccountDetails')
        context.dispatch('getPersonalDetails')
        context.dispatch('getWalletBalance', response.result.login)
        context.dispatch('overlayState/deactivateLoginDialog')
        if (config.app.autoconf.EXTERNAL_WALLET_PROVIDER === 'IGTC') {
          context.dispatch('fetchIgtcLastLoginDetails')
        }
        context.commit('setLoginChallenges', null)
        context.commit('setLoginChallengesTermsConditions', null)
        context.commit('setSessionDetails', response.result.login)
        context.commit('setLoginTime', Date.now())
        Vue.set(localStorage, 'loginTime', Date.now())
        context.dispatch('pageRedirection')
        config.customCookies.setCookie('sessionDetails', response.result.login)
        if (!context.getters['getWebViewAndMobile'] && !context.getters['getIsOpenedFromWebView']) {
          var playerId = response.result.login.geolocationUserId
          if (window.ctsautoconf.MOCKUP_GEOCOMPLY !== undefined) {
            if (!window.ctsautoconf.MOCKUP_GEOCOMPLY) {
              geocomply.geoComplyService(playerId, false, 'Login')
            } else {
              geocomply.geoComplyMockupService(true) // true/false - success/failed geolocation
            }
          } else {
            geocomply.geoComplyService(playerId, false, 'Login')
          }
        }
      } else if (response && response.result && !response.result.exceptionType && response.result.status === 'OUTSTANDING_CHALLENGE' && response.result.challenge.Name === 'STRONG_AUTH') {
        // CompleteChallenge
        context.commit('setLoginErrorMessage', '')
        context.commit('setLoginChallenges', response.result.login)
      } else if (response && response.result && !response.result.exceptionType && response.result.status === 'OUTSTANDING_CHALLENGE' && response.result.challenge.Name === 'TERMS_AND_CONDITIONS') {
        // CompleteChallenge
        context.commit('setLoginErrorMessage', '')
        context.commit('setLoginChallengesTermsConditions', response.result.login)
      } else {
        // login failed
        context.commit('setLoginErrorMessage', response.error_message || 'Unknown error occurred')
        context.commit('setPersonalDetails', undefined)
        context.commit('setSessionDetails', undefined)
      }
    },
    onLoginError (state, error) {
      state.dispatch('onLoginSuccess', error)
      state.commit('setLoginErrorMessage', error.message || 'Login failed. Unknown error occurred')
      state.commit('setPersonalDetails', undefined)
      state.commit('setSessionDetails', undefined)
    },
    sessionTransferWithTempId (context, tempSessionId) {
      lib.rpcService.callBroker('SharedWalletService', 'GetSessionByTempID', {
        'tempSessionId': tempSessionId,
        'IDDCLanguage': config.app.language
      }).then(response => {
        if (response && response.result && !response.result.exceptionType) {
          // logged in
          var sessionToken = response.result
          context.commit('setLoginErrorMessage', '')
          context.dispatch('getSessionDetails', sessionToken).then((result) => {
            if (result && result.IDMMCustomer) {
              context.dispatch('forcedLoginWithDetails', {
                'sessionToken': sessionToken,
                'IDMMCustomer': result.IDMMCustomer
              })
            } else {
              context.commit('setAccountDetails', undefined)
              context.commit('setLoginErrorMessage', response.result.message || 'Login failed. Unknown error occurred')
            }
          }).catch((error) => {
            context.commit('setAccountDetails', undefined)
            context.commit('setLoginErrorMessage', error || 'Login failed. Unknown error occurred')
          })
        } else {
          // login failed
          context.commit('setAccountDetails', undefined)
          context.commit('setLoginErrorMessage', response.result.message || 'Login failed. Unknown error occurred')
        }
      }).catch((error) => {
        context.commit('setAccountDetails', undefined)
        context.commit('setLoginErrorMessage', error.message || 'Login failed. Unknown error occurred')
      })
    },
    forcedLoginWithDetails (context, request) {
      lib.rpcService.callBroker('UserService', 'ForcedLoginWithDetails', {
        'sessionToken': request.sessionToken,
        'IDMMCustomer': request.IDMMCustomer
      }).then((response) => {
        if (response && !response.exceptionType) {
          context.dispatch('getPersonalDetails')
          context.dispatch('getAccountDetails')
        } else {
          context.commit('setLoginErrorMessage', 'Login failed. Unknown error occurred')
          context.dispatch('getPersonalDetails')
          context.commit('setAccountDetails', undefined)
        }
      }).catch((error) => {
        context.commit('setLoginErrorMessage', error.message || 'Login failed. Unknown error occurred')
        context.dispatch('getPersonalDetails')
        context.commit('setAccountDetails', undefined)
      })
    },
    logout (context) {
      if (router.currentRoute.name !== 'logout') {
        router.push('/sports')
      }
      context.commit('setPageLoader', true)
      lib.rpcService.callBroker('IGTConnectService', 'Logout', {'device': context.getters['getDevice']}).then(() => {
        // context.commit('sbBetslipState/setActiveBetSlipHistoryTab', '')
        context.commit('setLoginErrorMessage', '')
        if (context.getters['getIsOpenedFromWebView']) {
          mobileBridge.mobileLogout()
        }
      }).catch((error) => {
        context.commit('setLoginErrorMessage', error.message || 'Logout failed. Unknown error occurred')
      }).finally(() => {
        context.commit('setPersonalDetails', undefined)
        context.commit('setAccountDetails', undefined)
        localStorage.removeItem('last-keep')
        context.commit('sbBetslipState/clearBetSlip')
        context.dispatch('sbBetslipState/resetBetSlipChanges')
        context.commit('sbBetslipState/setActiveBetSlipHistoryTab', '')
        context.commit('sbBetslipState/setTab', 'REGULAR')
        localStorage.removeItem('loggedIn')
        if (!context.getters['getIsOpenedFromWebView']) {
          context.commit('overlayState/setGeolocationMessage', {})
          localStorage.setItem('geoError', false)
          geocomply.method.geoComplyDisconnectService()
        }
        context.commit('setPageLoader', false)
      })
    },
    clearAccountDetails (context) {
      context.commit('setAccountDetails', undefined)
    },
    getAccountDetails (context) {
      return lib.rpcService.callBroker('AccountService', 'GetAccountsDetails', {}).then(response => {
        if (response.result) {
          context.commit('setAccountDetails', response.result)
        } else {
          context.commit('setAccountDetails', undefined)
        }
        return response
      })
    },
    getOnePayToken (context) {
      return lib.rpcService.callBroker('IGTConnectService', 'GetOnePayToken', {'device': context.getters['getDevice'], IDMDRegion: 'ignore', IDMDLanguage: 'ignore'}).then(response => {
        if (response.result) {
          context.commit('setOnePayToken', response.result.token)
        } else {
          context.commit('setOnePayToken', undefined)
        }
        return response
      })
    },
    validateSession (context) {
      return lib.rpcService.callBroker('IGTConnectService', 'ValidateSession', {
        'session_id': 'TODO - pass the session id here',
        'device': context.getters['getDevice']
      }).then(response => {
        Vue.set(localStorage, 'loginTime', (Date.now() - response.result.currentSessionTimeMillis) || Date.now())
        config.customCookies.setCookie('sessionDetails', response.result)
      })
    },
    igtcCheckSession (context) {
      return lib.rpcService.callBroker('IGTConnectService', 'SessionCheck', {
        IDMDRegion: 'ignore',
        IDMDLanguage: 'ignore',
        'device': context.getters['getDevice']
      }).then(response => {
        Vue.set(localStorage, 'loginTime', (Date.now() - response.result.currentSessionTimeMillis) || Date.now())
        config.customCookies.setCookie('sessionDetails', response.result)
      })
    },
    getWalletBalance (context) {
      console.log('getWalletBalance')

      lib.rpcService.callBroker('IGTConnectService', 'GetBalance', {'device': context.getters['getDevice']}).then(response => {
        // session expired on external wallet
        if (!(response.result && response.result.balances) || (response.result && response.result.balances && response.result.balances.length === 0)) {
          context.dispatch('logout')
        }
        if (response.result) {
          context.commit('setWalletBalance', response.result)
        } else {
          context.commit('setWalletBalance', undefined)
        }
      }).catch((error) => {
        console.log(error)
        context.commit('setWalletBalance', undefined)
        // session expired on external wallet
        context.dispatch('logout')
      })
    },
    getPersonalDetails (context) {
      lib.rpcService.callBroker('UserService', 'GetPersonalDetails', {}).then(response => {
        if (response.result) {
          context.commit('setPersonalDetails', response.result)
        } else {
          context.commit('setPersonalDetails', undefined)
        }
      }).catch(() => {
        context.commit('setPersonalDetails', undefined)
      })
    },
    getSessionDetails (context, sessionToken) {
      return new Promise((resolve, reject) => {
        lib.rpcService.callBroker('SharedWalletService', 'GetSessionDetails', {
          'sessionToken': sessionToken,
          'IDDCLanguage': config.app.language
        }).then(response => {
          if (response.result) {
            resolve(response.result)
          } else {
            return undefined
          }
        }).catch((error) => {
          reject(error)
        })
      })
    },
    softGeolocation (context) {
      var softVerifiedResult = JSON.parse(sessionStorage.getItem('softVerifiedResult'))
      var countryName, USstate, stateName, currentState, errorCode
      if (softVerifiedResult === null) {
        lib.rpcService.callBroker('GeoLocationService', 'Locate', {}).then(response => {
          if (response.result) {
            countryName = response.result.Country.Name
            USstate = response.result.MostSpecificSubdivision.IsoCode
            stateName = response.result.MostSpecificSubdivision.Name
            currentState = window.ctsautoconf.STATE
            USstate = (countryName === 'United Kingdom') ? 'LND' : USstate // for testing usage
            console.log('response', response.result)
            if (currentState !== USstate) {
              sessionStorage.setItem('softVerifiedResult', JSON.stringify({ 'located': false, 'USstate': USstate, 'stateName': stateName, 'countryName': countryName }))
              if (context.state.optionalISOStates.includes(USstate)) {
                context.dispatch('softGeolocationRedirect', {USstate, stateName})
              }
            } else {
              sessionStorage.setItem('softVerifiedResult', JSON.stringify({ 'located': true, 'USstate': USstate, 'stateName': stateName, 'countryName': countryName }))
            }
          }
        }).catch(() => {
          errorCode = 'softGeolocation'
          context.commit('overlayState/setGeolocationMessage', { errorCode })
          context.dispatch('overlayState/activeGeolocationDialog')
        })
      } else {
        if (!softVerifiedResult.located) {
          USstate = (softVerifiedResult.countryName === 'United Kingdom') ? 'LND' : softVerifiedResult.USstate // for testing usage
          if (context.state.optionalISOStates.includes(USstate)) {
            let sn = softVerifiedResult.stateName
            context.dispatch('softGeolocationRedirect', {USstate, sn})
          }
        }
      }
    },
    softGeolocationRedirect (context, data) {
      var url
      var stateISO = data.USstate
      var stateName = data.stateName
      var stateCodeStorage = sessionStorage.getItem('stateCode')
      var errorCode = 'softGeolocationRedirect'
      if (context.state.optionalISOStates.includes(stateISO)) {
        url = window.ctsautoconf.WESTVIRGINIA
      }
      var pathAndState = { stateISO, url, stateName }
      if (stateCodeStorage !== null) {
        if (stateCodeStorage !== stateISO) {
          sessionStorage.setItem('stateCode', stateISO)
          if (localStorage.getItem('siteVisited') === null) {
            localStorage.setItem('siteVisited', true)
            setTimeout(() => {
              context.commit('overlayState/setGeolocationMessage', { errorCode, pathAndState })
              context.dispatch('overlayState/activeGeolocationDialog')
            }, 5000)
          } else {
            window.open(url, '_self')
          }
        }
      } else {
        sessionStorage.setItem('stateCode', stateISO)
        if (localStorage.getItem('siteVisited') === null) {
          localStorage.setItem('siteVisited', true)
          setTimeout(() => {
            context.commit('overlayState/setGeolocationMessage', { errorCode, pathAndState })
            context.dispatch('overlayState/activeGeolocationDialog')
          }, 5000)
        } else {
          window.open(url, '_self')
        }
      }
    },
    setIsOpenedFromWebView (context, isOpenedFromWebView) {
      context.commit('setIsOpenedFromWebView', isOpenedFromWebView)
    },
    igtcServiceGetSsoToken (context, request) {
      console.log('IGTConnectService GetSsoToken')

      return new Promise((resolve, reject) => {
        lib.rpcService.callBroker('IGTConnectService', 'GetSsoToken', {
          'ssoToken': request.ssoToken,
          'device': context.getters['getDevice']
        }).then(response => {
          if (response.result) {
            if (response.result === 'OK') {
              resolve(response.result)
            } else {
              context.dispatch('logout')
            }
          } else {
            return undefined
          }
        }).catch((error) => {
          reject(error)
        })
      })
    },
    getWinningTransaction (context) {
      context.commit('setFormSubmitSppiner', true)
      lib.rpcService.callBroker('IGTConnectService', 'WinningTransaction', {
        'brandId': null,
        'thpId': null,
        'transactionId': null,
        'transactionStatus': null,
        'witholdingTax': null,
        'fromCreationDate': null,
        'toCreationDate': null,
        'fromConfirmedDate': null,
        'toConfirmedDate': null
      }).then(response => {
        if (response.result) {
          context.commit('setWinningTransaction', response.result)
        } else {
          context.commit('setWinningTransaction', undefined)
        }
        context.commit('setFormSubmitSppiner', false)
      }).catch((error) => {
        console.log(error)
        context.commit('setWinningTransaction', undefined)
        context.commit('setFormSubmitSppiner', false)
      })
    },
    geoComplyGetLicense (context) {
      return lib.rpcService.callBroker('IGTConnectService', 'GetLicence', {
        'getLicenceRequest': {},
        'device': context.getters['getDevice']
      })
    },
    geoComplyCheckGeoLocation (context, data) {
      console.log('geoComplyCheckGeoLocation')
      console.log(data.geoPacket)
      return lib.rpcService.callBroker('IGTConnectService', 'CheckGeoLocation', {
        'checkGeoLocationRequest': {
          'GeoToken': data.geoPacket
        },
        'device': context.getters['getDevice']
      })
    },
    pageRedirection () {
      let routes = ['account-register', 'account-forgottenpassword', 'account-resetpassword', 'account-activate']
      let currentRoute = router.currentRoute.name
      if (routes.includes(currentRoute)) {
        router.push('/sports')
      }
    },
    mobileGeolocated (context) {
      if (context.getters['getIsOpenedFromWebView']) {
        let isMobileGeolocated = ('mobileGeolocated' in localStorage) ? JSON.parse(localStorage.mobileGeolocated) : false
        context.commit('setGeolocated', isMobileGeolocated)
      }
    }
  },
  modules: {
    meetingState,
    raceState,
    resultsState,
    betslipState,
    // playHistoryState,
    statementState,
    accountState,
    siteNavigationState,
    bonavigationState,
    marketgroupState,
    sbBetslipState,
    livebettingState,
    screenState,
    overlayState,
    eventState,
    tncState,
    geocomply
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js